const LANGUAGES = {
  en: {
    name: 'English',
    nativeName: 'English',
    color: '#00B0FF',
  },
  de: {
    name: 'German',
    nativeName: 'Deutsch',
    color: '#ED5565',
  },
  fr: {
    name: 'French',
    nativeName: 'Français',
    color: '#f8ac59',
  },
  it: {
    name: 'Italian',
    nativeName: 'Italiano',
    color: '#23c6c8',
  },
  es: {
    name: 'Spanish',
    nativeName: 'Español',
    color: '#fadb14',
  },
  th: {
    name: 'Thai',
    nativeName: 'ไทย',
    color: '#292648',
  },
  ko: {
    name: 'Korean',
    nativeName: '한국어',
    color: '#2D589C',
  },
  ja: {
    name: 'Japanese',
    nativeName: '日本語',
    color: '#BE0029',
  },
  nl: {
    name: 'Dutch',
    nativeName: 'Nederlands',
    color: '#ff0000',
  },
  pl: {
    name: 'Polish',
    nativeName: 'Polski',
    color: '#DC143C',
  },
  da: {
    name: 'Danish',
    nativeName: 'Dansk',
    color: '#C60C30',
  },
  no: {
    name: 'Norwegian',
    nativeName: 'Norsk',
    color: '#003087',
  },
  sv: {
    name: 'Swedish',
    nativeName: 'Svenska',
    color: '#FFCD00',
  },
  fi: {
    name: 'Finnish',
    nativeName: 'Suomi',
    color: '#1244c8',
  },
  pt: {
    name: 'Portuguese',
    nativeName: 'Português',
    color: '#eb2f96',
  },
  zh: {
    name: 'Chinese',
    nativeName: '汉语',
    color: '#00ffff',
  },
  ar: {
    name: 'Arabic',
    nativeName: 'العَرَبِيَّة',
    color: '#808080',
  },
  ro: {
    name: 'Romanian',
    nativeName: 'Română',
    color: '#330000',
  },
  uk: {
    name: 'Ukrainian',
    nativeName: 'Українська',
    color: '#005BBB',
  },
  bg: {
    name: 'Bulgarian',
    nativeName: 'български',
    color: '#eb672f',
  },
  cs: {
    name: 'Czech',
    nativeName: 'Čeština',
    color: '#d7141a',
  },
  sl: {
    name: 'Slovenian',
    nativeName: 'Slovenščina',
    color: '#003DA5',
  },
} as const;

type LanguageCode = keyof typeof LANGUAGES;

export default LANGUAGES;
export { type LanguageCode };
